import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const getMediaQuery = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(QUERY)
    : null;

/** True when the visitor has asked the OS to reduce motion. */
export default function usePrefersReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(
    () => getMediaQuery()?.matches ?? false
  );

  useEffect(() => {
    const mediaQuery = getMediaQuery();
    if (!mediaQuery) return undefined;

    const handleChange = (event) => setPrefersReducedMotion(event.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return prefersReducedMotion;
}
